import BotMessage from "./impl/BotMessage";
import DecryptNormalMessage from "./impl/DecryptNormalMessage";
import EncryptStatus from "./impl/EncryptStatus";
import ErrorMessage from "./impl/ErrorMessage";
import MessageEncryptStatus from "./impl/MessageEncryptStatus";
import SenderKeyMessage from "./impl/SenderKeyMessage";
import EncryptionErrorNotifier from "./impl/EncryptionErrorNotifier";

class CipherMessageManager {
  constructor() {
    this.senderKeyMessageUtils = new SenderKeyMessage();
    this.errorMessageUtils = new ErrorMessage();
    this.decryptNormalMessage = new DecryptNormalMessage();
    this.botMessage = new BotMessage();
    this.encryptStatus = new EncryptStatus();
    this.messageEncrypt = new MessageEncryptStatus();
    this.encryptionErrorNotifier = new EncryptionErrorNotifier(this.decryptNormalMessage);
  }
}

export default CipherMessageManager;
